import React, { useContext, useState } from 'react';
import { useFormik } from "formik";
import { SignInValidation } from "../../components/Validation";
import { useNavigate } from 'react-router-dom';
import MandatoryLabel from '../../components/common/label';
import { InputErrorMessage } from '../../components/errorMessages';
import { IoEye, IoEyeOff } from 'react-icons/io5';
import { EditProfileLoader } from '../../components/common/loader';
import { commonUsedClass, mobileLoginViewtalwind, } from './MobileLoginTalwind';
import { getProfileById, loginApi, userAuth } from '../../apis';
import { toast } from 'react-hot-toast';
import { AppContext } from '../../appContext';

export default function LogInForm({ runOneSignal, setFPWDSec,referral }) {
  const  { userDetails ,setUserDetails} =useContext(AppContext);
  const [loader, setLoader] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: '', password: '', keepMeLoggedIn: false },
    validationSchema: SignInValidation,
    onSubmit: async (values) => {
      const { email, password } = values;
      try {
        setLoader(true);
        const res = await userAuth({
          email: email,
          password: password,
          keepLoggedIn: true,
        });
        if (res.status == 200) {
          console.log(res.data.userId);
          // setToken(res.data.token);
          localStorage.setItem('userId', res.data.userId);
          checkUserApproval(res.data.userId, res.data.token);
          setLoader(false);
          localStorage.setItem('tempToken', res.data.token);
          // navigate('/registration');
        }
      } catch (error) {
        setLoader(false);
        console.log(error)
        const message = error.response.data.error || error.response.statusText;
        toast.error(message, { id: 'error' });
      }
    },
  });
  const checkUserApproval = async (id, token) => {
    try {
      const res = await getProfileById(id);
      if (res.status == 200) {
        if (res.data.Profile.DoctorProfile != null) {
          if (res.data.Profile.DoctorProfile.isApproved) {
            localStorage.setItem('token', token);
            setUserDetails(res.data.Profile);
            await runOneSignal(res.data.Profile.DoctorProfile?._id)
            navigate('/');
          } else {
            if (referral) {
                navigate(`/registration?Referral_code=${encodeURIComponent(referral)}`, {
                  replace: true,
                });
              }
              else{
                 navigate('/registration');
             }
          }
        } else {
              if (referral) {
                navigate(`/registration?Referral_code=${encodeURIComponent(referral)}`, {
                  replace: true,
                });
              }
              else{
                 navigate('/registration');
             }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleChange = (e) => {
    e.preventDefault();
    formik.handleChange(e);
  };

  function handelPasswordType() {
    if (passwordType == 'text') {
      setPasswordType('password');
    } else if (passwordType == 'password') {
      setPasswordType('text');
    }
  }

  function handelForgotPasswordModal() {
    setFPWDSec(true);
  }

  return (
    <>
      <form className="LogInForm" onSubmit={formik.handleSubmit}>
        <div className="relative">
          <MandatoryLabel title="Email" />
          <input
            type="text"
            name="email"
            className={
              Boolean(formik.touched.email) && Boolean(formik.errors.email)
                ? commonUsedClass.inpNormal
                : commonUsedClass.inpErr
            }
            id="email"
            placeholder="Email"
            value={formik.values.email}
            onChange={handleChange}
          />
          <InputErrorMessage
            error={formik.touched.email && formik.errors.email}
          />
        </div>
        <div className="relative">
          <MandatoryLabel title="password" />
          <div className="relative">
            <input
              type={passwordType}
              name="password"
              className={
                Boolean(formik.touched.password) &&
                  Boolean(formik.errors.password)
                  ? commonUsedClass.inpNormal
                  : commonUsedClass.inpErr
              }
              id="password"
              placeholder="Password "
              value={formik.values.password}
              onChange={handleChange}
            />
            <div
              className={commonUsedClass.pwdEye}
              onClick={handelPasswordType}
            >
              {passwordType == 'password' ? (
                <IoEyeOff />
              ) : passwordType == 'text' ? (
                <IoEye />
              ) : (
                <></>
              )}
            </div>
          </div>
          <InputErrorMessage
            error={formik.touched.password && formik.errors.password}
          />
        </div>

        <div className={mobileLoginViewtalwind.loginRMFPCon}>
          <div className={mobileLoginViewtalwind.rememberMeCon}>
            <input
              type="checkbox"
              className="mt-0.5"
              id="keepMeLoggedIn"
              name="keepLoggedIn"
              onChange={(e) =>
                formik.setFieldValue(
                  'keepMeLoggedIn',
                  e.target.checked ? true : false
                )
              }
              value={formik.values.keepMeLoggedIn}
            />
            <label
              className={mobileLoginViewtalwind.rememberMe}
              htmlFor="keepMeLoggedIn"
            >
              Remember Me
            </label>
          </div>
          <p
            className={mobileLoginViewtalwind.forgotpassword}
            onClick={handelForgotPasswordModal}
          >
            Forgot Password?
          </p>
        </div>
        <div className="signButton mt-6 space-y-2">
          <button
            className={commonUsedClass.btncon}
            type="submit"
          >
            {!loader ? (
              'Log In'
            ) : (
              <div className="text-xs">
                <EditProfileLoader />
              </div>
            )}
          </button>
          <div
            className={mobileLoginViewtalwind.DLcon}
          >
            <span className={mobileLoginViewtalwind.DLNormalTxt}>Don’t have an account?</span>  <span className={mobileLoginViewtalwind.DLLinkTxt} onClick={() => navigate('/sign-up')}>Join us</span>
          </div>
        </div>
      </form>

    </>
  );
}